export default __webpack_public_path__ + "static/media/mobile-menu.bf50ed33.svg";